import { connect, useSelector } from 'react-redux';

import { GlobalState } from 'ha/types/store';

import { FeatureFlags } from './types';
import { getFeatureFlags } from './selectors';

interface StateProps {
  featureFlags: FeatureFlags;
}

const mapStateToProps = (state: GlobalState): StateProps => ({
  featureFlags: getFeatureFlags(state),
});

interface ReturnType {
  featureFlags: FeatureFlags;
  children: (featureFlags: FeatureFlags) => JSX.Element | null;
}

export default connect(mapStateToProps)((props: ReturnType) =>
  props.children(props.featureFlags),
);

export function useFeatureFlags() {
  const { featureFlags } = useSelector(mapStateToProps);

  return featureFlags;
}
